import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import CustomLinearProgress from "../../components/CustomLinearProgress/CustomLinearProgress";

class AccountSeriesProgress extends React.Component {

	constructor(props, context) {
		super(props, context);
		this.state = {
			per: Math.round(this.props.done / this.props.all * 100),
			color: '#ccc',
			colorName: ''
		};

		if (this.state.per === 100) {
			this.state.color = '#4caf50';
			this.state.colorName = 'success';
		}else if (this.state.per >= 60) {
			this.state.color = '#ff9800';
			this.state.colorName = 'warning';
		}else if (this.state.per > 0) {
			this.state.color = '#f44336';
			this.state.colorName = 'danger';
		}else {
			this.state.color = '#2c5364';
			this.state.colorName = 'primary';
		}

	}

	render() {
		return (
			<Box display="flex" alignItems="center">
				<Box minWidth={40}>
					<Typography variant="body2"
								style={{color: this.state.color}}
					>{`${Math.round(
						this.state.per
						// this.props.value,
					)}%`}</Typography>
				</Box>
				<Box width="100%" mr={1}>

					<CustomLinearProgress
						variant="determinate"
						color={this.state.colorName}
						value={this.state.per}
						style={{margin: '0px'}}
					/>

				</Box>
				<Box minWidth={35}   justify="flex-end">
					<Typography variant="body2"
								style={{color: this.state.color}}
					>
						{this.props.done}
						<span style={{color: '#a9a9a9'}}>
						/{this.props.all}
					</span>
					</Typography>
				</Box>
			</Box>

		);
	}

}

export default AccountSeriesProgress